<template lang="pug">
    .landingpage

        //.header-area(v-if="areas.header && areas.header.length")
            HeaderArea(:sections="areas.header")

        .section(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
            Heading(
                v-if="section.key === 'heading'" :section="section"
                heading-class="is-size-2-desktop is-size-3-tablet is-size-4-mobile has-text-weight-light"
                sub-heading-class="is-size-6 is-uppercase has-text-primary"
            )
            Slider(v-if="section.key === 'slider'" :section="section")
            CategoryPosts(
                v-if="section.key === 'categoryposts'"
                :section="section"
                :per-page="3"
                orientation="horizontal"
            )
            Banners(v-if="section.key === 'banners'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            MapBox(v-if="section.key === 'mapbox'" :section="section")

</template>

<script>

// import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import Heading from '@/components/Heading'
import Slider from '@/components/Slider'
import CategoryPosts from '@/components/CategoryPosts'
import Banners from '@/components/Banners'
import Post from '@/components/Post'
import MapBox from '@/components/MapBox'

export default {
    name: 'LandingPage',
    components: {
        Heading,
        Slider,
        CategoryPosts,
        Banners,
        Post,
        MapBox,
    },
    computed: {
        ...mapGetters('currentPage', {
            sections: 'sections',
        })
    }
}

</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .landingpage
        background-image: url('~@/assets/aba_bg.png')
        background-repeat: no-repeat
        background-position: center 20px

        +widescreen-only
            background-position: center 50px
            background-size: 1710px auto
        +desktop-only
            background-position: center 40px
            background-size: 1600px auto
        +tablet-only
            background-position: center -70px


        .content
            padding-bottom: 20px

    .section.slider,
    .section.banners,
    .section.mapbox
        padding: 0

    .section.heading
        padding-bottom: 0
        & /deep/
            h2
                max-width: 800px
                margin: 0 auto !important
                text-align: center
                font-weight: 500 !important
                font-size: 1.4rem !important

</style>
